module.exports = __webpack_public_path__ + "static/media/secreativo.a3dc7f6d.svg";